import {
    SETTINGS_DRIVER_UPDATE,
    SETTINGS_DRIVER_UPDATE_RESPONSE,
    SETTINGS_DRIVER_DELETE,
    SETTINGS_DRIVER_DELETE_RESPONSE,
    SETTINGS_DRIVER_OPEN_DELETE_MODAL,
    SETTINGS_DRIVER_LOAD_CSV,
    SETTINGS_DRIVER_LOAD_CSV_RESPONSE,
    SETTINGS_DRIVER_SEARCH_TRANSACTIONS,
    SETTINGS_DRIVER_SEARCH_TRANSACTIONS_RESPONSE,
    SETTINGS_DRIVER_OPEN_DRIVER_TRANSACTION_MODAL,
    SETTINGS_DRIVER_GET_URL_FILE,
    SETTINGS_DRIVER_GET_URL_FILE_RESPONSE,
    SETTINGS_DRIVER_OPEN_CLOSE_FILTERS,
    SETTINGS_DRIVER_SET_ENTITY,
    SETTINGS_DRIVER_OPEN_DELETE_DRIVERS_TAG_MODAL,
    SETTINGS_DRIVER_AVATAR,
    SETTINGS_DRIVER_AVATAR_RESPONSE,
} from "Redux/actionTypes";


export const openDriverTransactionModal = (open) => {
  return {
      type: SETTINGS_DRIVER_OPEN_DRIVER_TRANSACTION_MODAL,
      payload: { open }
  };
};

export const loadDriverCsv = (data) => {
  return {
      type: SETTINGS_DRIVER_LOAD_CSV,
      payload: data,
  };
};

export const loadDriverCsvResponse = (data) => {
  return {
      type: SETTINGS_DRIVER_LOAD_CSV_RESPONSE,
      payload: data,
  };
};

export const searchTransactions = (data) => {
  return {
      type: SETTINGS_DRIVER_SEARCH_TRANSACTIONS,
      payload: data,
  };
};

export const searchTransactionsResponse = (data) => {
  return {
      type: SETTINGS_DRIVER_SEARCH_TRANSACTIONS_RESPONSE,
      payload: data,
  };
};

export const getUrlFileCsv = (data) => {
  return {
      type: SETTINGS_DRIVER_GET_URL_FILE,
      payload: data,
  };
};

export const getUrlFileCsvResponse = (data) => {
  return {
      type: SETTINGS_DRIVER_GET_URL_FILE_RESPONSE,
      payload: data,
  };
};

export const openCloseDriversFilters = (open) => {
  return {
      type: SETTINGS_DRIVER_OPEN_CLOSE_FILTERS,
      payload: { open },
  };
};

export const setDriversEntity = (entity) => {
  return {
      type: SETTINGS_DRIVER_SET_ENTITY,
      payload: { entity },
  };
};

export const openDriversTagDeleteModal = (open, items) => {
  return {
      type: SETTINGS_DRIVER_OPEN_DELETE_DRIVERS_TAG_MODAL,
      payload: { open, items }
  };
};

export const uploadDriverAvatar = (data) => {
  return {
      type: SETTINGS_DRIVER_AVATAR,
      payload: data,
  };
};

export const uploadDriverAvatarResponse = (data) => {
  return {
      type: SETTINGS_DRIVER_AVATAR_RESPONSE,
      payload: data,
  };
};
